import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/customerDue/dueController";

import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        condition : { 
          ...(formData.get('users_name')?{users_name : { $regex: formData.get('users_name'), $options: "i" }}:null),
          ...(formData.get('last_name')?{last_name : { $regex: formData.get('last_name'), $options: "i" }}:null),
          ...(formData.get('users_mobile')?{users_mobile : parseInt(formData.get('users_mobile'))}:null),
          ...(formData.get('store_name')?{store_name : { $regex: formData.get('store_name'), $options: "i" }}:null),
          ...(formData.get('bind_person_name')?{bind_person_name : { $regex: formData.get('bind_person_name'), $options: "i" }}:null),
          ...(formData.get('pos_number')?{pos_number : parseInt(formData.get('pos_number'))}:null)
         },
         select : {
          users_name : true,
          last_name : true,
          users_mobile : true,
          users_email : true,
          pos_number : true,
          old_due_amount : true,
          due_amount : true,
          bind_person_name : true,
          store_name : true,
          status : true
         }
      }
      const res = await list(option);
      if(res.status === true){
        if(res.result && res?.result?.length > 0){
          const modifyData = await Promise.all(res?.result.map((item, index) => {
            return {
              "SL.NO."       : index + 1,
              // "FIRST NAME"   : item?.users_name,
              // "LAST NAME"    : item?.last_name,
              // "EMAIL"        : item?.users_email || 'N/A',
              "POS NUMBER"   : item?.pos_number || 'N/A',
              "STORE NAME"   : item?.store_name || 'N/A',
              "MOBILE"       : item?.users_mobile,
              "BIND WITH"    : item?.bind_person_name || 'N/A',
              "OLD DUE AMOUNT": item?.old_due_amount?.toFixed(2) || '0.00',
              "DUE AMOUNT"   : item?.due_amount?.toFixed(2) || '0.00',
              "STATUS"       : item?.status
            };
          }));
          await exportToExcel(modifyData);
        }
        handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `K-Winn users due list ${moment().format('YYYY=MM-DD HH:mm')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export customer's due
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="users_name" className="all_lable_for_vendor_dashbaord" >First Name : </label>
                      <input type="text" name="users_name" id="users_name" placeholder="Enter first name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="last_name" className="all_lable_for_vendor_dashbaord" > Last Name : </label>
                      <input type="text" name="last_name" id="last_name" placeholder="Enter last name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_mobile" className="all_lable_for_vendor_dashbaord" > Mobile number : </label>
                      <input type="number" name="users_mobile" id="users_mobile" placeholder="Enter user's mobile number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="pos_number" className="all_lable_for_vendor_dashbaord" > POS number : </label>
                      <input type="number" name="pos_number" id="pos_number" placeholder="Enter POS number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_person_name" className="all_lable_for_vendor_dashbaord" > Bind with user's name : </label>
                      <input type="text" name="bind_person_name" id="bind_person_name" placeholder="Enter bind whit user's name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="store_name" className="all_lable_for_vendor_dashbaord" > Store's Name : </label>
                      <input type="text" name="store_name" id="store_name" placeholder="Enter user's store" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
